import { HttpClient } from '@angular/common/http';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config';
import { CustomTranslateLoader } from './custom-translate-http-loader';
import { EventBusService } from '@signature-it/ngx-generic/services';

export function HttpTranslateLoaderFactory(http: HttpClient, restUrls: RestUrlsConfig, eventBusService: EventBusService) {
    return new CustomTranslateLoader(http, restUrls, eventBusService);
}
